import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FilesPathComponent } from './files-path.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: FilesPathComponent,
    data: {
      title: "Other Files Path",
      breadcrumb: "Other Files Path"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class FilespathRoutingModule { }